import { createSelector } from '@ngrx/store';
import { getActiveComponent } from 'src/app/shared/selectors/eliqua.selectors';
import { getDragonflyState } from '../reducers';

export const getSideNavState = createSelector(getDragonflyState, (state) => state?.sidenav);

export const getSidenavStatus = createSelector(getSideNavState, (state) => state?.sidenavStatus);

export const getAssignCheckbook = createSelector(
  getSideNavState,
  (state) => state?.assignCheckbook,
);

export const getRenderAssignCheckbook = createSelector(
  getAssignCheckbook,
  getActiveComponent,
  (assignCheckbook, activeComponent) =>
    activeComponent === 'SearchCheckbooksComponent' && assignCheckbook,
);

export const getCheckbookGroupTemplate = createSelector(
  getSideNavState,
  (state) => state?.checkbookGroupTemplate,
);

export const getRenderCheckbookGroupTemplate = createSelector(
  getCheckbookGroupTemplate,
  getActiveComponent,
  getAssignCheckbook,
  (checkbookGroupTemplate, activeComponent, assignCheckbook) =>
    activeComponent === 'SearchGroupTemplatesComponent' &&
    checkbookGroupTemplate &&
    !assignCheckbook,
);
